import { render, staticRenderFns } from "./booking-details.vue?vue&type=template&id=d5d3b50a&"
import script from "./booking-details.vue?vue&type=script&lang=js&"
export * from "./booking-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports